<!--
@component Text input.

   Main properties:
   - `value` - the entered value, bindable, default: `''`.
   - `placeholder` - text for place holder, default: `''`.
   - `maxLength` - maximum number of symbols that can be entered, default: `25`.
   - `validator` - function to validate the inpute value (should return error message or empty string)
-->
<script>
   let {
      value = $bindable(''),        // initial selected value
      className = '',               // extra class name
      placeholder = '',             // placeholder (hint)
      maxLength = 25,               // maximum number of characters
      validator = null,             // validator callback, returns error message if value is not valid (empty if it is).
   } = $props();

   let error = $state('')

   function validate() {
      if (!validator) return;
      error = validator(value);
   }
</script>

<div class="textinput {className}" class:error={error && error.length > 0}>
<input type="text" {placeholder} maxlength={maxLength} bind:value={value} oninput={validate}>
{#if error && error.length > 0}<div class="error-message">{error}</div>{/if}
</div>

<style>

   .textinput {
      box-sizing: border-box;
      flex: 1 1 auto;
      /* height: 1.5em; */
      font-size: 1em;
      line-height: 1.5em;
      margin: 0;
      padding: 0.15em 0;
      width: auto;
      border-radius: 2px;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      display: flex;
      position: relative;
   }

   .textinput > input {
      flex: 1 1 auto;
      font-size: 0.9em;
      width: 100%;
      cursor: default;
      padding: 0.25em 0.5em;
      border: 1px solid;
      border-radius: 0.3em;
      outline: none;
   }

   .textinput > input:focus,
   .textinput > input:active {
      border: 1px solid;
   }

   .error-message {
      position: absolute;
      left: 0;
      bottom: calc(100% + 2px);
      border-radius: 0.3em;
      line-height: 1em;
      font-size: 0.75em;
      padding:0.5em;
   }
</style>
